/* eslint-disable @typescript-eslint/no-explicit-any */
import { getRequest, postRequest } from 'features/common'
import { QueryParameters } from '@deck.gl/carto'
import { Credentials, executeSQL as cartoExecuteSQL } from '@carto/react-api'
import { SQLResponse } from '../types'
import { REQUEST_GET_MAX_URL_LENGTH } from '@carto/react-core'
import { SQL_API } from './urls'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const sendSQLRequest = async ({
  connection,
  query,
  extraParams = {},
  queryParameters,
  refresh
}: {
  connection: string
  query: string
  extraParams?: Record<string, any>
  queryParameters?: QueryParameters
  refresh?: boolean
}): Promise<SQLResponse | undefined> => {
  const baseUrl = `${SQL_API}/${connection}/query`
  if (!query) return
  const searchParams = new URLSearchParams({
    q: query,
    ...extraParams,
    ...(queryParameters ? { queryParameters: JSON.stringify(queryParameters) } : {})
  }).toString()
  let opts = {}
  if (refresh) {
    opts = {
      headers: {
        'Cache-Control': 'no-cache'
      }
    }
  }
  const url = `${baseUrl}?${searchParams}`
  if (url.length > REQUEST_GET_MAX_URL_LENGTH) {
    return sendSQLPostRequest({ connection, query, extraParams, queryParameters, opts })
  } else {
    return await getRequest(url, opts)
  }
}

export const sendSQLPostRequest = async ({
  connection,
  query,
  extraParams = {},
  queryParameters,
  opts = {}
}: {
  connection: string
  query: string
  extraParams?: Record<string, any>
  queryParameters?: QueryParameters | null
  opts?: RequestInit
}): Promise<SQLResponse | undefined> => {
  const url = `${SQL_API}/${connection}/query`
  if (!query) return
  return await postRequest(url, { q: query, ...extraParams, ...(queryParameters && { queryParameters }) }, opts)
}

export const executeSQLWithRetries = async <T>({
  credentials,
  query,
  queryParameters,
  connection,
  opts,
  retry = 0
}: {
  credentials: Credentials
  query: string
  queryParameters?: QueryParameters
  connection: string
  opts?: unknown
  retry?: number
}) => {
  let lastError
  for (let i = 0; i <= retry; i++) {
    try {
      return cartoExecuteSQL<T>({
        credentials,
        query,
        queryParameters,
        connection,
        opts
      })
    } catch (error) {
      lastError = error
    }
  }
  throw new Error(lastError)
}
